import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ConfigItem, CreateIndexDto, IndexItem } from '../shared/interfaces';

@Injectable({
  providedIn: 'root'
})
export class IndexService {
  private readonly http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiUrl}/index`;

  getIndices(): Observable<IndexItem[]> {
    return this.http.get<IndexItem[]>(`${this.apiUrl}`);
  }

  getAvailableEmbedders(): Observable<ConfigItem[]> {
    return this.http.get<string[]>(`${this.apiUrl}/enums/embedder`).pipe(
      map((strings: string[]) => {
        return strings.map(str => ({ name: str }));
      })
    );
  }

  getAvailableProviders(): Observable<ConfigItem[]> {
    return this.http.get<string[]>(`${this.apiUrl}/enums/provider`).pipe(
      map((strings: string[]) => {
        return strings.map(str => ({ name: str }));
      })
    );
  }

  // Crea il nuovo indice
  createIndex(payload: CreateIndexDto) {
    return this.http.post<void>(`${this.apiUrl}`, payload);
  }

  deleteIndex(name: string) {
    return this.http.delete(`${this.apiUrl}/${name}`,
      { responseType: 'text' }
    );
  }
}